import { Dispatch, Action, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { SalesActivityModuleState } from "../../..";

export enum VendorOpportunityActionTypes {
	SHOW_VENDOR_OPPORTUNITY_LOADER = "SHOW_VENDOR_OPPORTUNITY_LOADER",
	HIDE_VENDOR_OPPORTUNITY_LOADER = "HIDE_VENDOR_OPPORTUNITY_LOADER",
	OPEN_ADD_OPPORTUNITY_DRAWER = "OPEN_ADD_OPPORTUNITY_DRAWER",
	CLOSE_ADD_OPPORTUNITY_DRAWER = "CLOSE_ADD_OPPORTUNITY_DRAWER",
	OPEN_EDIT_OPPORTUNITY_DRAWER = "OPEN_EDIT_OPPORTUNITY_DRAWER",
	CLOSE_EDIT_OPPORTUNITY_DRAWER = "CLOSE_EDIT_OPPORTUNITY_DRAWER"
}

export type ShowVendorOpportunityLoaderAction =
	Action<VendorOpportunityActionTypes.SHOW_VENDOR_OPPORTUNITY_LOADER>;
export type HideVendorOpportunityLoaderAction =
	Action<VendorOpportunityActionTypes.HIDE_VENDOR_OPPORTUNITY_LOADER>;

export type OpenAddOpportunityDrawerAction =
	Action<VendorOpportunityActionTypes.OPEN_ADD_OPPORTUNITY_DRAWER>;
export type CloseAddOpportunityDrawerAction =
	Action<VendorOpportunityActionTypes.CLOSE_ADD_OPPORTUNITY_DRAWER>;
export type OpenEditOpportunityDrawerAction =
	Action<VendorOpportunityActionTypes.OPEN_EDIT_OPPORTUNITY_DRAWER>;
export type CloseEditOpportunityDrawerAction =
	Action<VendorOpportunityActionTypes.CLOSE_EDIT_OPPORTUNITY_DRAWER>;

export type VendorOpportunityActions =
	| ShowVendorOpportunityLoaderAction
	| HideVendorOpportunityLoaderAction
	| OpenAddOpportunityDrawerAction
	| CloseAddOpportunityDrawerAction
	| OpenEditOpportunityDrawerAction
	| CloseEditOpportunityDrawerAction;

export interface VendorOpportunityDispatch {
	showVendorOpportunityLoader: ActionCreator<
		ThunkAction<
			ShowVendorOpportunityLoaderAction,
			SalesActivityModuleState,
			null,
			ShowVendorOpportunityLoaderAction
		>
	>;
	hideVendorOpportunityLoader: ActionCreator<
		ThunkAction<
			HideVendorOpportunityLoaderAction,
			SalesActivityModuleState,
			null,
			HideVendorOpportunityLoaderAction
		>
	>;
	openAddOpportunityDrawer: ActionCreator<
		ThunkAction<
			OpenAddOpportunityDrawerAction,
			SalesActivityModuleState,
			null,
			OpenAddOpportunityDrawerAction
		>
	>;
	closeAddOpportunityDrawer: ActionCreator<
		ThunkAction<
			CloseAddOpportunityDrawerAction,
			SalesActivityModuleState,
			null,
			CloseAddOpportunityDrawerAction
		>
	>;
	openEditOpportunityDrawer: ActionCreator<
		ThunkAction<
			OpenEditOpportunityDrawerAction,
			SalesActivityModuleState,
			null,
			OpenEditOpportunityDrawerAction
		>
	>;
	closeEditOpportunityDrawer: ActionCreator<
		ThunkAction<
			CloseEditOpportunityDrawerAction,
			SalesActivityModuleState,
			null,
			CloseEditOpportunityDrawerAction
		>
	>;
}

export const VendorOpportunityActionCreators: VendorOpportunityDispatch = {
	showVendorOpportunityLoader: () => {
		return (dispatch: Dispatch): ShowVendorOpportunityLoaderAction => {
			const showVendorOpportunityLoaderAction: ShowVendorOpportunityLoaderAction =
				{
					type: VendorOpportunityActionTypes.SHOW_VENDOR_OPPORTUNITY_LOADER
				};
			return dispatch(showVendorOpportunityLoaderAction);
		};
	},
	hideVendorOpportunityLoader: () => {
		return (dispatch: Dispatch): HideVendorOpportunityLoaderAction => {
			const hideVendorOpportunityLoaderAction: HideVendorOpportunityLoaderAction =
				{
					type: VendorOpportunityActionTypes.HIDE_VENDOR_OPPORTUNITY_LOADER
				};
			return dispatch(hideVendorOpportunityLoaderAction);
		};
	},
	openAddOpportunityDrawer: () => {
		return (dispatch: Dispatch): OpenAddOpportunityDrawerAction => {
			const openOpportunityDrawerAction: OpenAddOpportunityDrawerAction =
				{
					type: VendorOpportunityActionTypes.OPEN_ADD_OPPORTUNITY_DRAWER
				};
			return dispatch(openOpportunityDrawerAction);
		};
	},
	closeAddOpportunityDrawer: () => {
		return (dispatch: Dispatch): CloseAddOpportunityDrawerAction => {
			const closeOpportunityDrawerAction: CloseAddOpportunityDrawerAction =
				{
					type: VendorOpportunityActionTypes.CLOSE_ADD_OPPORTUNITY_DRAWER
				};
			return dispatch(closeOpportunityDrawerAction);
		};
	},
	openEditOpportunityDrawer: () => {
		return (dispatch: Dispatch): OpenEditOpportunityDrawerAction => {
			const openOpportunityDrawerAction: OpenEditOpportunityDrawerAction =
				{
					type: VendorOpportunityActionTypes.OPEN_EDIT_OPPORTUNITY_DRAWER
				};
			return dispatch(openOpportunityDrawerAction);
		};
	},
	closeEditOpportunityDrawer: () => {
		return (dispatch: Dispatch): CloseEditOpportunityDrawerAction => {
			const closeOpportunityDrawerAction: CloseEditOpportunityDrawerAction =
				{
					type: VendorOpportunityActionTypes.CLOSE_EDIT_OPPORTUNITY_DRAWER
				};
			return dispatch(closeOpportunityDrawerAction);
		};
	}
};

export default VendorOpportunityActionCreators;
